/**
 * 表示用のフェーズ計算（サーバー時刻補正済みの now を渡す）。
 * 認可には一切使わない。実際の制限はサーバー側（functions/cloud-run のゲート）が行う。
 */
export const HOUR_MS = 60 * 60 * 1000;
export const BANNER_AFTER_MS = 24 * HOUR_MS;
export const GRACE_MS = 72 * HOUR_MS;

export type DisplayPhase = 'loading' | 'none' | 'A' | 'B' | 'C';

export function computeDisplayPhase(params: {
  emailVerified: boolean;
  applicable: boolean;
  creationMs: number;
  nowMs: number;
}): Exclude<DisplayPhase, 'loading'> {
  if (params.emailVerified || !params.applicable) return 'none';
  const elapsed = params.nowMs - params.creationMs;
  if (elapsed >= GRACE_MS) return 'C';
  if (elapsed >= BANNER_AFTER_MS) return 'B';
  return 'A';
}

export function formatRemaining(ms: number): { hours: number; minutes: number } {
  const total = Math.max(0, Math.floor(ms / 60000));
  return { hours: Math.floor(total / 60), minutes: total % 60 };
}
